import { render } from "./SiteBroadcast.vue?vue&type=template&id=5b2067db"
import script from "./SiteBroadcast.vue?vue&type=script&setup=true&lang=js"
export * from "./SiteBroadcast.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/SitesDash/manage/SiteBroadcast.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "5b2067db"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('5b2067db', __exports__)) {
    api.reload('5b2067db', __exports__)
  }
  
  module.hot.accept("./SiteBroadcast.vue?vue&type=template&id=5b2067db", () => {
    api.rerender('5b2067db', render)
  })

}


export default __exports__